<template>
  <div style="max-height: 42px; overflow: auto;" class="flex items-center h-full">
    <span style="word-break: break-word; white-space: normal" class="flex flex-wrap items-center h-full">
      <span v-for="(tag, tagIndex) in allTag" :key="tagIndex">
        <vs-chip color="success" type="filled" style="line-height: normal;" class="tag-style">
          <span v-if="tag.tag && tag.tag.name">{{ tag.tag.name }}</span>
        </vs-chip>
        <span v-if="tagIndex + 1 < allTag.length"> </span
      ></span>
    </span>
  </div>
</template>
<script>
export default {
  name: "TagShow",
  props: {
    tags: [Object, Array],
  },
  mounted () {
    this.allTag = this.params ? this.params.data.tags : this.tags;
  },
  data () {
    return {
      allTag: [],
    };
  },
};
</script>

<style>
.con-vs-chip {
  padding: 5px !important;
  border-radius: 5px !important;
}
</style>
